import { EmailGroup } from './email-group.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from 'app/core/http/url.service';
import { UserGroup } from './user-group.model';

@Injectable({
  providedIn: 'root'
})
export class ManageEmailPreferencesService {

  public constructor(
    private readonly httpClient: HttpClient,
    private readonly urlService: UrlService) {
  }

  public getEmailGroups(): Observable<EmailGroup[]> {
    const url = this.urlService.buildServerApiUrl('Account/EmailGroups');

    return this.httpClient.get<EmailGroup[]>(url);
  }

  public updateUserGroups(userGroups: UserGroup[]): Observable<EmailGroup[]> {
    const url = this.urlService.buildServerApiUrl('Account/EmailGroups');

    return this.httpClient.post<EmailGroup[]>(url, userGroups);
  }

  public unsubscribeFromGroup(groupId: string ): Observable<{ Name: string }> {
    const url = this.urlService.buildServerApiUrl('account', 'emailgroup', groupId, 'unsubscribe');

    return this.httpClient.post<{ Name: string}>(url, { groupId });
  }
}
